import { faAsterisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import { Tooltip } from "react-tooltip";

type Option = {
  key: string | number;
  name: string;
  isDeleted?: boolean;
  department?: string;
  [key: string]: any;
};

interface SelectObjectState {
  initialOption?: string;
  label: string;
  value: any;
  options: Option[] | null | undefined;
  onUpdate: (selected: any | null) => void;
  disabled?: boolean;
  skipInitialOption?: boolean;
  cssClasses?: string;
  required?: boolean;
  testId?: string;
  hasFocus?: boolean;
}

const SelectObject = ({
  initialOption = "Select from List",
  label,
  value,
  options,
  onUpdate,
  disabled = false,
  skipInitialOption = false,
  cssClasses = "",
  required = false,
  testId = "",
  hasFocus = false,
}: SelectObjectState) => {
  const inputRef = useRef<HTMLSelectElement>(null);
  
  useEffect(() => {
    if (hasFocus) {
      inputRef?.current?.focus();
    }
  }, []);

  return (
    <>
      {required ? (
        <>
          <FloatingLabel controlId="floatingInput" label={<span className={`${cssClasses} text-truncate`}>{label}</span>}>
            <FontAwesomeIcon
              className="app-tertiary-color-inverse"
              icon={faAsterisk}
              style={{ position: "absolute", right: 5, top: 5, fontSize: 11 }}
            />
            <Form.Select
              id="floatingInput"
              className={`${cssClasses} decorated`}
              value={value || ""}
              onChange={(e) => onUpdate(e)}
              disabled={disabled}
              ref={inputRef}
            >
              {skipInitialOption === false && (
                <option key={0} value={0}>
                  {initialOption}
                </option>
              )}
              {options?.map((i: any, index: any) => (
                <option key={index} value={i.key} className={i.isDeleted ? "text-muted" : ""}>
                  {i.name}
                  {i.department ? " - " + i.department : ""}
                  {i.isDeleted ? "->deleted" : ""}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
          <Tooltip id="tooltip" place="top" style={{ padding: "5px 10px", zIndex: "1100" }} />
        </>
      ) : (
        <FloatingLabel controlId="floatingInput" label={<span className={`${cssClasses} text-truncate`}>{label}</span>}>
          <Form.Select
            id="floatingInput"
            data-testid={testId ? testId : label}
            className={`${cssClasses} decorated`}
            value={value || ""}
            onChange={(e) => onUpdate(e)}
            disabled={disabled}
            ref={inputRef}
          >
            {skipInitialOption === false && (
              <option key={0} value={0}>
                {initialOption}
              </option>
            )}
            {options?.map((i: any, index: any) => (
              <option key={index} value={i.key} className={i.isDeleted ? "text-muted" : ""}>
                {i.name}
                {i.department ? " - " + i.department : ""}
                {i.isDeleted ? "->deleted" : ""}
                {i.is_archived ? "->archived" : ""}
              </option>
            ))}
          </Form.Select>
        </FloatingLabel>
      )}
    </>
  );
};
export default SelectObject;
